'use strict';

module.exports = /*@ngInject*/
function(
    ApiConfig,
    SecureInterceptorService
) {
    return {
        getProduct(slug) {
            return SecureInterceptorService.get({
                queryParams: { slug: slug },
                url: ApiConfig.product
            });
        }
    };
};
